import { Loader2Icon } from 'lucide-react'

import { cn } from '../../../lib/utils'

export function DetailLoading({ message }: { message: string }) {
  return (
    <div className="flex items-center gap-2 py-12 text-sm text-ink-3">
      <Loader2Icon className="size-4 animate-spin" />
      <span>{message}</span>
    </div>
  )
}

export function DetailError({ message }: { message: string }) {
  return (
    <div
      role="alert"
      className="rounded-lg border border-st-down/40 bg-st-down-bg px-4 py-3 text-sm text-st-down"
    >
      {message}
    </div>
  )
}

export function InlineAlert({
  kind,
  children,
  className
}: {
  kind: 'info' | 'warn' | 'down'
  children: React.ReactNode
  className?: string
}) {
  const tone =
    kind === 'down'
      ? 'border-st-down/40 bg-st-down-bg text-st-down'
      : kind === 'warn'
        ? 'border-st-warn/40 bg-st-warn-bg text-st-warn'
        : 'border-st-info/40 bg-st-info-bg text-st-info'
  return (
    <div role="alert" className={cn('rounded-lg border px-3 py-2 text-sm', tone, className)}>
      {children}
    </div>
  )
}
